import { forwardRef } from 'react';

import classNames from 'classnames';

type TLabelProps = React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
>;

export const Label = forwardRef<HTMLLabelElement, TLabelProps>(
    ({ className, ...props }, ref) => {
        return (
            <label
                className={classNames('font-med', className)}
                ref={ref}
                {...props}
            />
        );
    }
);

Label.displayName = 'Label';
